import { mix } from 'polished'
import styled from 'styled-components'

import { Base } from './Base'

type Props = {
	isHidden: boolean
	square?: boolean
}

export const Placeholder = styled(Base)<Props>`
	z-index: 1;
	background-color: ${({ theme }) => mix(0.2, theme.color.text, theme.color.background)};
	opacity: ${({ isHidden }) => (isHidden ? 0 : 1)};
`
